// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2x-1";
export var rateTableServiceLevelDropdown = "_2x-3";
export var rateTableTypeDropdown = "_2x-0";
export var rateTableValueModeDropdown = "_2x-2";